/*
 * @Author: Json Chen
 * @Date: 2021-07-26 15:14:42
 * @LastEditTime: 2021-07-26 15:15:58
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/localisation/index.ts
 */

import { get, post } from 'src/tools/server';

export const getLocalisation = () => {
  return get<any>(`/portal/setting/store/localisation`, {});
};

export const setLocalisation = (body: any) => {
  return post<any>(`/portal/setting/store/localisation`, body, {});
};
